<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getCo } from "@/api/api";
export default {
  name: "App",
  data() {
    return {
      timer: null 
    };
  },
  // 解决安卓手机调出来软键盘，屏幕背景被挤压的问题
  created() {
    // 获取当前可视区域的高度
    const height = document.documentElement.clientHeight;
    // 在页面整体加载完毕时
    window.onload = function() {
      // 把获取到的高度赋值给根div
      document.getElementById("app").style.height = `${height}px`;
    };
    
    if (localStorage.getItem("appUtype") == 3) {
        this.updateCo();
      if (this.timer) {
        clearInterval(this.timer);
      } else {
        this.timer = setInterval(() => {
          this.updateCo();
        }, 600000);
      }
    }
  },
  methods: {
        updateCo() {
      let options = {
        enableHighAccuracy: true,
        maximumAge: 10000
      };
      if (navigator.geolocation) {
        //浏览器支持geolocation
        navigator.geolocation.getCurrentPosition(
          this.success(),
          this.onError,
          options
        );
      } else {
        //浏览器不支持geolocation
        this.$toast.fail("浏览器不支持定位");
      }
    },
    success() {
      return position => {
        if(position.coords.accuracy <=10){
        let lng = position.coords.longitude;
        let lat = position.coords.latitude;
        this.$store.commit("updateCO", [lng, lat]);
        let creatDate = new Date();
        let para = {
          appUid: localStorage.getItem("appUid"),
          trackJson: {
            lat: lat,
            lon: lng,
            caretadate: creatDate.toLocaleDateString()
          }
        };
        getCo(para).then(res => {
          if (res.data.code === 600) {
            console.log("定位上传成功");
          }
        });
        } else {
                  let lng = position.coords.longitude;
        let lat = position.coords.latitude;
        this.$store.commit("updateCO", [lng, lat]);
        this.lat1 = lat;
        this.lng1 = lng;
        this.setCurrentLocation(lng, lat, flag);
        }

      };
    },
  }
};
</script>

<style>
html,
body,
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue